import { render, staticRenderFns } from "./DetachmentsOfflineOnlineTable.vue?vue&type=template&id=20664a9d&scoped=true&"
import script from "./DetachmentsOfflineOnlineTable.vue?vue&type=script&lang=js&"
export * from "./DetachmentsOfflineOnlineTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20664a9d",
  null
  
)

export default component.exports